const getCurrencyForOrder = (order) => {
  if (order.name.startsWith('#UK')) return '£';
  if (order.name.startsWith('#EU')) return '€';
  if (order.name.startsWith('#SH') || order.name.startsWith('#AU') || order.type === 'CORPORATE_RENTAL_10') return '$';
  return '';
};

export default getCurrencyForOrder;
